
import { defineComponent, PropType } from 'vue'

import { VideoAttributes } from '@/types/models/video'
import HomeLatestVideosCarouselCard from '@/components/HomeLatestVideosCarouselCard.vue'
import HomeLatestVideosCarouselFull from '@/components/HomeLatestVideosCarouselFull.vue'
import { useStore } from '@/store/index'

export default defineComponent({
  props: {
    videos: {
      type: Array as PropType<VideoAttributes[] | undefined>,
      'default': () => ([]),
    }
  },
  components: { HomeLatestVideosCarouselFull, HomeLatestVideosCarouselCard },
  setup() {
    const store = useStore()
    return {
      store
    }
  },
})
